import { createFileRoute, notFound } from "@tanstack/react-router";
import { BlogPostPage } from "@/components/blog/BlogPages";
import { blogPostHead } from "@/components/blog/blog-head";
import { getBlogPost } from "@/lib/blog.functions";

// Статья блога (ru). Нет опубликованной статьи с таким slug на этом языке — 404.
export const Route = createFileRoute("/blog/$slug")({
  loader: async ({ params }) => {
    const res = await getBlogPost({ data: { lang: "ru", slug: params.slug } });
    if (!res.post) throw notFound();
    return { post: res.post, translations: res.translations };
  },
  head: ({ loaderData }) => (loaderData ? blogPostHead(loaderData.post, loaderData.translations) : {}),
  component: function Page() {
    const { post, translations } = Route.useLoaderData();
    return <BlogPostPage post={post} translations={translations} />;
  },
});
